<script lang="ts" setup>
  import BvLoader from '@bv/components/icons/loading/BvLoader.vue';

  import SelectArrowIcon from './SelectArrowIcon.vue';

  withDefaults(
    defineProps<{
      loading?: boolean;
      size?: 'sm' | 'md';
      isMenuOpen?: boolean;
    }>(),
    {
      loading: false,
      size: 'md',
      isMenuOpen: false,
    },
  );
</script>

<template>
  <div class="bv-select__toggle">
    <bv-loader
      v-if="loading"
      :width="size === 'sm' ? '12px' : '16px'"
    />
    <select-arrow-icon
      v-else
      :class="size === 'sm' ? 'size-3' : 'size-4'"
      :direction="isMenuOpen ? 'up' : 'down'"
    />
  </div>
</template>
